import { Injectable } from '@angular/core';
import { BuyerData } from '../../../../core/model';
import { OccPermissionNormalizer } from '../../../../core/occ/adapters';
import { Converter } from '../../../../core/util';

@Injectable({ providedIn: 'root' })
export class BuyerDataNormalizer implements Converter<any | undefined, BuyerData | undefined> {
  constructor(private occPermissionNormalizer: OccPermissionNormalizer) {}

  convert(source: any): BuyerData | undefined {
    return source
      ? {
          ...source,
          permissions: source.permissions?.map((p) => this.occPermissionNormalizer.convert(p)),
        }
      : undefined;
  }
}
